import React from 'react';

import { Checkbox } from '@notino/react-styleguide-v20';

import { DropDownQuantitySelector } from '@sharedComponents/Inputs';
import { CartPrice } from '@sharedComponents/Prices';
import { StyledPointerEventsWrapper } from '@styles/generalStyles';

import { FinalServicePrice } from './components/FinalServicePrice';

interface IIconColumn {
  disabled: boolean;
  active: boolean;
}
export const IconColumn =
  (onClick: () => void) =>
  ({ active, disabled }: IIconColumn) => <Checkbox checked={active} disabled={disabled} onChange={onClick} />;

interface IBodyColumn {
  disabled: boolean;
}
export const BodyColumn =
  (title: string | JSX.Element, onChildClick: (e: React.MouseEvent) => boolean) =>
  ({ disabled }: IBodyColumn) => (
    <StyledPointerEventsWrapper disabled={disabled} onClick={onChildClick}>
      {title}
    </StyledPointerEventsWrapper>
  );

interface IPriceColumn {
  active: boolean;
}
export const PriceColumn = (
  totalPriceDataTestId?: string,
  isDualPriceLayout: boolean = false,
  price?: number,
  freePriceText?: JSX.Element | string,
) =>
  price !== undefined && freePriceText !== undefined
    ? ({ active }: IPriceColumn) => (
        <FinalServicePrice
          isActive={active}
          className={totalPriceDataTestId}
          price={price}
          freePriceText={freePriceText}
          isDualPriceLayout={isDualPriceLayout}
        />
      )
    : null;

interface IInfoColumn {
  disabled: boolean;
}
export const InfoColumn =
  (infoText: JSX.Element | React.ReactNode, onChildClick: (e: React.MouseEvent) => boolean) =>
  ({ disabled }: IInfoColumn) => (
    <StyledPointerEventsWrapper disabled={disabled} onClick={onChildClick}>
      {infoText}
    </StyledPointerEventsWrapper>
  );

interface IAdditionalColumn {
  disabled: boolean;
}
export const AdditionalColumn = (
  additionalInfoComponent: JSX.Element | React.ReactNode,
  onChildClick: (e: React.MouseEvent) => boolean,
) =>
  additionalInfoComponent
    ? ({ disabled }: IAdditionalColumn) => (
        <StyledPointerEventsWrapper disabled={disabled} onClick={onChildClick}>
          {additionalInfoComponent}
        </StyledPointerEventsWrapper>
      )
    : null;

export const PerPieceColumn = (
  pricePerPiece?: number,
  itemPriceDataTestId?: string,
  isDualPriceLayout: boolean = false,
) =>
  pricePerPiece
    ? () => (
        <CartPrice
          className={itemPriceDataTestId}
          price={pricePerPiece}
          isDualPriceLayout={isDualPriceLayout}
          isColumnLayout={true}
        />
      )
    : null;

export const PiecesColumn = (unit: string, pieces?: number, quantityDataTestId?: string) =>
  pieces
    ? () => (
        <DropDownQuantitySelector className={quantityDataTestId} currentQuantity={pieces} unit={unit} disabled={true} />
      )
    : null;
